import { FC } from 'react'

import styles from '../styles/Acceptance.module.scss'

const AcceptPartnerEnglish: FC = () => (
	<div className={styles.policy} lang='en'>
		<div className='container'>
			<div className='row'>
				<div className='col-12'>
					<div className={styles.wrapper}>
						<h1>PARTNERSHIP AGREEMENT</h1>
						<h2>(public offer agreement)</h2>
						<h3>PODCASTBERY</h3>
						<p className={styles.addr}>
							Effective date: January 26, 2026
							<br />
							Moscow, revision dated June 18, 2026
						</p>

						<p>
							This document constitutes an offer (a public offer) by Individual Entrepreneur Viktoria
							Aleksandrovna Kazantseva (Taxpayer Identification Number (INN) 245211492400, Primary State
							Registration Number of an Individual Entrepreneur (OGRNIP) 326246800097782) (hereinafter, the
							“<b>Operator</b>”) to enter into an agreement on the terms set forth herein (hereinafter, the
							“<b>Offer</b>”) with any person who accepts it in accordance with Section 1.3 of this Offer.
						</p>

						<p>
							<b>KEY TERMS</b>
						</p>
						<p>
							<b>Acceptance of the Offer</b> means the Provider’s completion of the actions stipulated in
							Section 1.3 of this Offer for the selected Plan, signifying full and unconditional acceptance
							of all terms of the Offer and the documents specified in Section 1.4.
						</p>
						<p>
							<b>Agreement</b> means the agreement between the Operator and the Provider concluded by acceptance
							of this Offer on the terms of the selected Plan.
						</p>
						<p>
							<b>Provider (Studio)</b> means a legal entity or individual entrepreneur who has accepted this
							Offer in accordance with the selected Plan.
						</p>
						<p>
							<b>Provider Services</b> means services for the hourly rental of Rooms for creating audio and video
							content, as well as other additional services rendered by the Provider to the Customer.
						</p>
						<p>
							<b>Room</b> means a space about which information has been provided by the Provider and published
							by the Operator on the Website.
						</p>
						<p>
							<b>Website (Service)</b> means the Operator’s online information resource available at{' '}
							<a href='https://podcastbery.ru/'>https://podcastbery.ru/</a>.
						</p>
						<p>
							<b>Customer</b> means a person who contacts the Operator or the Provider intending to book the
							Provider’s Room.
						</p>
						<p>
							<b>Subscription Plan (Plan)</b> means one of the Operator’s service packages (“Standart,” “PRO,” or
							“Premium”) defining the scope of the Parties’ rights and obligations and the procedure for their
							interaction and settlements. Detailed Plan terms are set forth in Section 2.5 of this Offer and
							Appendix No. 2 (Plans), which forms an integral part hereof.
						</p>
						<p>
							<b>Dashboard</b> means a secure section of the Website available to Providers on the “PRO” and
							“Premium” Plans for managing information and Orders and interacting with the Operator.
						</p>
						<p>
							<b>Order</b> means a duly submitted Customer request for Provider Services.
						</p>

						<p>
							<b>1. GENERAL PROVISIONS</b>
						</p>
						<p>
							<b>1.1.</b> This Offer governs the relationship between the Parties under the Subscription Plan
							selected by the Provider: “Standart,” “PRO,” or “Premium.” The terms and functionality of each
							Plan differ and are detailed in the relevant sections of the Offer and in Appendix No. 2.
						</p>
						<p>
							<b>1.2.</b> This Offer is a public offer pursuant to Article 435 and Article 437(2) of the Civil Code
							of the Russian Federation. Acceptance of the Offer in the manner specified in Section 1.3
							constitutes conclusion of the Agreement on the terms set forth herein.
						</p>
						<p>
							<b>1.3.</b> Full and unconditional acceptance of this Offer shall mean the Provider’s consecutive
							completion of the following actions for the applicable Plan:
							<br />
							For all Plans:
							<br />
							1.3.1. Completing the registration form on the Website and providing the requested information
							about the Provider and the Room.
							<br />
							1.3.2. Sending copies of documents to info@podcastbery.ru for the Operator’s review (OGRN/OGRNIP
							registration certificate and a document confirming the right to use the premises).
							<br />
							<br />
							Additionally, for the “Standart” Plan:
							<br />
							1.3.3. Receiving the Operator’s notice confirming successful review and publication of the Room
							listing in the Website catalog.
							<br />
							<br />
							Additionally, for the “PRO” Plan:
							<br />
							1.3.4. Receiving access to the Dashboard from the Operator following successful review.
							<br />
							1.3.5. Completing the Room listing in the Dashboard in accordance with Section 2.2.2 of the
							Service Rules within seven (7) calendar days.
							<br />
							<br />
							Additionally, for the “Premium” Plan:
							<br />
							1.3.6. Selecting a billing period (month, quarter, or year) and paying the subscription fee in
							accordance with the current price list published on the Website.
							<br />
							1.3.7. Receiving access to the Dashboard from the Operator following successful review and
							payment.
							<br />
							1.3.8. Completing the Room listing in the Dashboard in accordance with Section 2.2.2 of the
							Service Rules within seven (7) calendar days.
						</p>
						<p>
							<b>1.4.</b> By accepting the Offer, the Provider confirms that it has fully reviewed, understands,
							and unconditionally accepts:
							<br />
							the terms of this Offer;
							<br />
							the Podcastbery Service Rules, which form an integral part of the Agreement;
							<br />
							the Privacy Policy published on the Website; and
							<br />
							the Plan terms set forth in Appendix No. 2 to this Offer.
						</p>
						<p>
							<b>1.5.</b> The relationship between the Parties shall be governed by the laws of the Russian
							Federation.
						</p>

						<p>
							<b>2. SUBJECT MATTER OF THE AGREEMENT. CONNECTION PROCEDURE</b>
						</p>
						<p>
							<b>2.1.</b> Under this Agreement, the Operator shall promote the Provider’s Room and facilitate
							interaction with Customers to the extent applicable to the selected Plan, while the Provider
							shall comply with the Agreement and, under the “PRO” and “Premium” Plans, pay the Operator’s
							remuneration.
						</p>
						<p>
							<b>2.2.</b> Connection to the Service shall be carried out in accordance with Section 1.3 of this
							Offer.
						</p>
						<p>
							<b>2.3. Terms of the “Standart” Plan:</b>
							<br />
							2.3.1. The Operator publishes the Room information supplied by the Provider in the Website’s
							general catalog in a limited format (up to three photographs, name, basic price list, and
							contact details). The Provider’s direct contact details (telephone and email) are published.
							<br />
							2.3.2. The Operator does not accept or process inquiries or bookings and does not accept
							payments. The Provider independently and directly handles all interaction with Customers,
							consultations, agreement of terms, booking confirmations, and payments.
							<br />
							2.3.3. Access to the Dashboard is not provided. Listing information may be updated no more than
							once every six months by sending a request to info@podcastbery.ru.
							<br />
							2.3.4. Participation under the “Standart” Plan is free of charge for the Provider.
							<br />
							2.3.5. Customers interested in booking the Provider’s Room contact the Provider directly using
							the telephone number or email address published in the Provider’s listing on the Website.
							<br />
							2.3.6. Provider obligations when working with customers. The Provider shall keep the contact
							information in its listing current; respond professionally and promptly to Customer inquiries
							received through the published contact details; and independently determine and agree with the
							Customer all terms of the services (date, time, price, scope of services, and cancellation and
							rescheduling rules).
						</p>
						<p>
							<b>2.4. Terms of the “PRO” Plan:</b>
							<br />
							2.4.1. The Operator provides the Provider with access to the Dashboard and enhanced features,
							including the online booking system and CRM.
							<br />
							2.4.2. A dedicated telephone number for the Operator’s contact center is published in the
							Provider’s listing. The Operator initially receives and processes Customer inquiries, provides
							consultations, and forwards inquiries to the Provider for further detailed processing and
							confirmation.
							<br />
							2.4.3. The Operator enables the acceptance of online payments from Customers through the
							Service.
							<br />
							2.4.4. The Operator’s remuneration is an agency fee (commission) equal to 20% of the final price
							of each completed Order (except video editing and audio post-production services, for which the
							commission is 10%).
							<br />
							2.4.5. The Operator transfers the funds received from Customers to the Provider, less the
							Operator’s remuneration, within two (2) business days after the service date.
						</p>
						<p>
							<b>2.5. Terms of the “Premium” Plan:</b>
							<br />
							2.5.1. The Operator provides the Provider with full access to Dashboard features, including
							priority placement in the catalog.
							<br />
							2.5.2. The Provider may publish its direct contact details in its listing. The Provider
							independently interacts and consults with Customers and confirms bookings.
							<br />
							2.5.3. The Operator does not charge an agency fee on Orders.
							<br />
							2.5.4. The Operator’s remuneration consists of a subscription fee paid by the Provider in
							advance for the selected period. The fee is determined by the current price list on the Website.
							<br />
							2.5.5. Automatic renewal is enabled. The fee for the next period is charged automatically three
							(3) calendar days before the end of the current paid period.
							<br />
							2.6. A detailed comparison table of the Plan terms is provided in Appendix No. 2, which forms an
							integral part of this Offer.
						</p>

						<p>
							<b>3. RIGHTS AND OBLIGATIONS OF THE PARTIES</b>
						</p>
						<p>
							<b>3.1. The Operator shall:</b>
							<br />
							3.1.1. Maintain the technical operation of the Website and its features to the extent provided
							by the selected Plan.
							<br />
							3.1.2. Review the information and documents supplied by the Provider.
							<br />
							3.1.3. Publish and maintain the Provider’s listing on the Website in accordance with the Plan
							terms.
						</p>
						<p>
							<b>3.2. The Operator may:</b>
							<br />
							3.2.1. Unilaterally amend this Offer, the Service Rules, and the Plans by notifying the Provider
							through publication of the new version on the Website at least ten (10) calendar days before the
							amendments take effect.
							<br />
							3.2.2. Refuse publication, remove a listing, or suspend access to the Dashboard if the Provider
							breaches the Agreement, supplies inaccurate information, or on other grounds specified in the
							Service Rules.
							<br />
							3.2.3. Charge the Provider an agency fee under the “PRO” Plan and a subscription fee under the
							“Premium” Plan in the prescribed amount and manner.
						</p>
						<p>
							<b>3.3. The Provider shall:</b>
							<br />
							3.3.1. Provide accurate, complete, and up-to-date information about itself and the Room.
							<br />
							3.3.2. Comply with the Agreement, the Service Rules, and the laws of the Russian Federation.
							<br />
							3.3.3. For the “PRO” and “Premium” Plans: complete and update information in the Dashboard in a
							timely manner and in full, promptly process inquiries, and update Order statuses.
							<br />
							3.3.4. Refrain from circumventing the Service to avoid paying the Operator’s remuneration (for
							the “PRO” Plan).
							<br />
							3.3.5. Bear full responsibility to the Customer for the quality and timely provision of the
							Services.
						</p>
						<p>
							<b>3.4. The Provider may:</b>
							<br />
							3.4.1. Use the Service features to the extent provided by the selected Plan.
							<br />
							3.4.2. Obtain advice on using the Service from the Operator’s support team.
							<br />
							3.4.3. Discontinue the partnership by sending the Operator written notice in accordance with
							Section 7.
						</p>

						<p>
							<b>4. SETTLEMENT PROCEDURE</b>
						</p>
						<p>
							<b>4.1.</b> Financial relations between the Parties are governed by Section 2 of this Offer (for
							each Plan) and detailed in Section 4 of the Service Rules.
						</p>
						<p>
							<b>4.2.</b> Under the “PRO” Plan, settlements are made for each Order. The Operator transfers funds
							to the Provider less the Operator’s remuneration within the time specified in Section 2.4.4.
						</p>
						<p>
							<b>4.3.</b> Under the “Premium” Plan, the Provider pays the subscription fee in advance. If the
							Provider terminates early, a refund is made in proportion to the unused time according to the
							refund schedule (Section 4.12.2.3 of the Service Rules), except that the fee for a 30-day period
							is non-refundable.
						</p>
						<p>
							<b>4.4.</b> All settlement disputes shall be resolved based on the monthly reports generated by the
							Operator in the Dashboard. A report is deemed approved unless the Provider submits reasoned
							objections within ten business days.
						</p>

						<p>
							<b>5. TERM, AMENDMENT, AND TERMINATION</b>
						</p>
						<p>
							<b>5.1.</b> The Agreement enters into force upon Acceptance by the Provider (Section 1.3) and
							continues until terminated.
						</p>
						<p>
							<b>5.2.</b> The Provider may unilaterally terminate the Agreement by sending written notice to the
							Operator at info@podcastbery.ru:
							<br />
							For the “Standart” Plan, the listing will be removed within five business days.
							<br />
							For the “PRO” Plan, access to the Dashboard will be terminated within five business days after
							all financial obligations have been fulfilled.
							<br />
							For the “Premium” Plan, notice must be sent no later than 24 hours before the next automatic
							charge date (or at any time if automatic renewal is disabled). Refunds are made according to the
							refund schedule in Section 4.12.2.3 of the Service Rules.
						</p>
						<p>
							<b>5.3.</b> The Operator may terminate the Agreement immediately, unilaterally and without a court
							order, if the Provider materially breaches the Agreement, including, without limitation, the
							violations specified in Sections 6 and 8 of the Service Rules.
						</p>
						<p>
							<b>5.4.</b> The Operator shall amend the Offer in accordance with Section 3.2.1. If the Provider
							does not agree with the amendments, it shall discontinue use of the Service in accordance with
							Section 5.2.
						</p>

						<p>
							<b>6. LIABILITY</b>
						</p>
						<p>
							<b>6.1.</b> The Parties shall be liable for failure to perform or improper performance of their
							obligations under the Agreement in accordance with the laws of the Russian Federation and the
							Agreement, including this Section and Section 6 of the Service Rules.
						</p>
						<p>
							<b>6.2. Provider liability:</b>
							<br />
							6.2.1. <b>Failed Order:</b> If a confirmed Order fails due to the Provider’s fault, the Provider
							shall pay the Operator a penalty of RUB 1,000 (one thousand rubles), as well as the full agency
							fee (for the “PRO” Plan) as though the Order had been completed (Section 6.1.1 of the Service
							Rules).
							<br />
							6.2.2. <b>Circumvention of the Service:</b> If, after receiving an inquiry or booking through the
							Service, the Provider and the Customer enter into an agreement for the same services directly,
							bypassing the Service, and the Provider intentionally fails to notify the Operator, the Provider
							shall pay the Operator:
							<br />
							a) twice the agency fee calculated on the Order price; and
							<br />
							b) a penalty equal to 20% of the price of that Order.
							<br />
							The Operator may also terminate the Agreement unilaterally and without a court order (Section
							6.9.1 of the Service Rules).
							<br />
							6.2.3. <b>Concealment of the Order price:</b> If the Provider intentionally conceals the full Order
							price from the Operator in order to reduce the agency fee, the Provider shall pay a penalty
							equal to twice the concealed fee, and the Operator may terminate the Agreement (Section 6.9.4
							of the Service Rules).
							<br />
							6.2.4. <b>Late payment:</b> If the Provider fails to transfer the commission to the Operator on
							time, the Provider shall pay a late charge of 0.1% of the unpaid amount for each day of delay,
							but no more than 10% of that amount (Section 5.3 of the Cooperation Agreement).
							<br />
							6.2.5. <b>Overlapping bookings:</b> If the Provider fails, through its own fault, to make the Room
							available to the Customer during the booked hours due to overlapping bookings, the Provider
							shall pay the Operator a penalty of RUB 1,000 (one thousand rubles) for each occurrence (Section
							6.1 of the Service Rules).
							<br />
							6.2.6. The Provider bears full responsibility to the Customer for the quality and timely
							provision of the Services and shall reimburse the Operator for all losses incurred in connection
							with third-party claims resulting from the Provider’s actions.
						</p>
						<p>
							<b>6.3. Operator liability:</b>
							<br />
							6.3.1. The Operator’s liability to the Provider is limited. If Website downtime attributable to
							the Operator results in failed bookings, the Operator’s liability is limited to the agency fees
							for those failed bookings (Section 6.5 of the Service Rules).
							<br />
							6.3.2. The Operator is not liable for:
							<br />
							a) losses incurred by the Provider in connection with use of the Service or interaction with
							Customers;
							<br />
							b) non-performance of obligations between the Provider and the Customer; or
							<br />
							c) the accuracy of information supplied by the Provider or Customers.
						</p>
						<p>
							<b>6.4. Operational measures:</b>
							<br />
							In the event of repeated violations (late status updates, concealment of information, etc.), the
							Operator may take measures against the Provider, including lowering its search ranking,
							involuntarily changing its Plan, or removing its listing (Section 3.7.2 of the Service Rules).
						</p>

						<p>
							<b>7. MISCELLANEOUS</b>
						</p>
						<p>
							<b>7.1.</b> The Agreement enters into force upon Acceptance by the Provider (Section 1.3) and
							continues until the Provider’s listing is removed from the catalog.
						</p>
						<p>
							<b>7.2.</b> If a court finds any provision of the Agreement invalid, the remaining provisions shall
							remain valid.
						</p>
						<p>
							<b>7.3.</b> All disputes shall be resolved by the court at the Operator’s place of business.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
)

export default AcceptPartnerEnglish
